import React from 'react';
import { useStore } from '../../../../../stores/root';

// assets

// services
import GeneralService from '../../../../../services/general';

// props
import { IOrderTruckResourceProps } from '../../../../../props/orders/trucks';

// components
import { Stack } from '@fluentui/react';
import Label from '../../../../typography/label';
import Text from '../../../../typography/text';
import OrderTruckGoodsList from '../../goods/list';
import Details from '../../../../typography/details';

interface IOrderTruckDetailsPropertiesProps {
    truck: IOrderTruckResourceProps;
}

const OrderTruckDetailsProperties: React.FC<IOrderTruckDetailsPropertiesProps> = (props: IOrderTruckDetailsPropertiesProps) => {
    const {truck} = props;
    const { banner } = useStore();
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [submitting, setSubmitting] = React.useState<boolean>(false);
    const [activeSurface, setActiveSurface] = React.useState<string | undefined>();

    return <Stack tokens={{ childrenGap: 20 }} styles={{root: {marginTop: 10}}}>
        <Details title={'Name'} text={truck.name || "-"} />
        <Stack horizontal tokens={{childrenGap: 20}}>
            <Details title={'Pick-up address'} text={truck.originAddress || "-"} style={{width: '50%'}} />
            <Details title={'Drop-off address'} text={truck.destinationAddress || "-"} style={{width: '50%'}} />
        </Stack>
        <Stack className={'divider'}></Stack>
        <Label size={'small'}>Pricing Details</Label>
        <Stack>
            <Details title={'Price'} text={`Rp. ${GeneralService.getNumberWithSeparator(truck.price)}`} />
            <Stack horizontal tokens={{childrenGap: 5}}>
                {truck.includePPn ? <Text size={'small'} className={'color-green'}>(include PPn)</Text> : null}
                {truck.includePPh ? <Text size={'small'} className={'color-green'}>(include PPh)</Text> : null}
                {!truck.includePPn ? <Text size={'small'} className={'color-red'}>(exclude PPn)</Text> : null}
                {!truck.includePPh ? <Text size={'small'} className={'color-red'}>(exclude PPh)</Text> : null}
            </Stack>
        </Stack>
        <Stack horizontal tokens={{childrenGap: 20}}>
            <Details title={`PPn (${truck.ppnPercentage}%)`} text={`Rp. ${GeneralService.getNumberWithSeparator(Number(truck.ppn))}`} style={{width: '50%'}} />
            <Details title={`PPh (${truck.pphPercentage}%)`} text={`Rp. ${GeneralService.getNumberWithSeparator(Number(truck.pph))}`} style={{width: '50%'}} />
        </Stack>
        <Stack horizontal tokens={{childrenGap: 20}}>
            <Details title={`Price (inc. PPn & PPh)`} text={`Rp. ${GeneralService.getNumberWithSeparator(truck.totalPrice)}`} style={{width: '50%'}} />
            <Details title={`Invoice price (total price - PPh)`} text={`Rp. ${GeneralService.getNumberWithSeparator(truck.invoicePrice)}`} style={{width: '50%'}} />
        </Stack>
        <Stack className='divider'></Stack>
        <Label size={'small'}>Goods List</Label>
        <OrderTruckGoodsList orderId={props.truck.orderId} truckId={props.truck.id} goods={props.truck.goods} />
    </Stack>
};

export default OrderTruckDetailsProperties;
